/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row?.bold ? "bold" : 400, fontSize: "14px", background: "transparent" }}
    >
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: { value: uuidV4() },
    type: "opening",

    recordDate: { value: null },
    voucherNumber: { value: null },
    voucherDate: { value: null },

    description: { value: "- Số dư đầu kỳ" },
    offsetAccount: { value: null },

    debit: { value: 0 },
    credit: { value: 0 },

    balanceDebit: { value: 0 },
    balanceCredit: { value: 0 },
  },

  {
    id: { value: uuidV4() },
    type: "normal",

    recordDate: { value: null },
    voucherNumber: { value: null },
    voucherDate: { value: null },

    description: { value: "- Số phát sinh trong kỳ" },
    offsetAccount: { value: null },

    debit: { value: 0 },
    credit: { value: 0 },

    balanceDebit: { value: 0 },
    balanceCredit: { value: 0 },
  },

  {
    id: { value: uuidV4() },
    type: "summary",

    recordDate: { value: null },
    voucherNumber: { value: null },
    voucherDate: { value: null },

    description: { value: "- Cộng số phát sinh" },
    offsetAccount: { value: null },

    debit: { value: "x" },
    credit: { value: "x" },

    balanceDebit: { value: "x" },
    balanceCredit: { value: "x" },
  },

  {
    id: { value: uuidV4() },
    type: "summary",

    recordDate: { value: null },
    voucherNumber: { value: null },
    voucherDate: { value: null },

    description: { value: "- Số dư cuối kỳ" },
    offsetAccount: { value: null },

    debit: { value: "x" },
    credit: { value: "x" },

    balanceDebit: { value: "x" },
    balanceCredit: { value: "x" },
  },
];

export default function WineTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newRow = {
      id: { value: uuidV4() },
      type: "normal",

      recordDate: { value: null },
      voucherNumber: { value: null },
      voucherDate: { value: null },

      description: { value: "" },
      offsetAccount: { value: "" },

      debit: { value: 0 },
      credit: { value: 0 },

      balanceDebit: { value: 0 },
      balanceCredit: { value: 0 },
    };

    setData((prev) => {
      // tìm vị trí dòng summary đầu tiên
      const insertIndex = prev.findIndex(
        (row) => row.type === "summary"
      );

      // nếu không có summary thì thêm cuối
      if (insertIndex === -1) {
        return [...prev, newRow];
      }

      // chèn vào giữa (trước summary)
      return [
        ...prev.slice(0, insertIndex),
        newRow,
        ...prev.slice(insertIndex),
      ];
    });
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          3 Các loại hóa đơn khác
        </Typography>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <thead>
            {/* Row 1 */}
            <tr>
              <Th rowSpan={2} style={{ textAlign: "center" }}>
                Ngày, tháng ghi sổ
              </Th>

              <Th colSpan={2} style={{ textAlign: "center" }}>
                Chứng từ
              </Th>

              <Th rowSpan={2} style={{ textAlign: "center" }}>
                Diễn giải
              </Th>

              <Th rowSpan={2} style={{ textAlign: "center" }}>
                TK đối ứng
              </Th>

              <Th colSpan={2} style={{ textAlign: "center" }}>
                Số phát sinh
              </Th>

              <Th colSpan={2} style={{ textAlign: "center" }}>
                Số dư
              </Th>
            </tr>

            {/* Row 2 */}
            <tr>
              <Th style={{ textAlign: "center" }}>Số hiệu</Th>
              <Th style={{ textAlign: "center" }}>Ngày, tháng</Th>

              <Th style={{ textAlign: "center" }}>Nợ</Th>
              <Th style={{ textAlign: "center" }}>Có</Th>

              <Th style={{ textAlign: "center" }}>Nợ</Th>
              <Th style={{ textAlign: "center" }}>Có</Th>
            </tr>

            {/* Row 3 */}
            <tr>
              <Th style={{ textAlign: "center" }}>A</Th>
              <Th style={{ textAlign: "center" }}>B</Th>
              <Th style={{ textAlign: "center" }}>C</Th>
              <Th style={{ textAlign: "center" }}>D</Th>
              <Th style={{ textAlign: "center" }}>E</Th>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
              <Th style={{ textAlign: "center" }}>3</Th>
              <Th style={{ textAlign: "center" }}>4</Th>
            </tr>
          </thead>

          <tbody>
            {data.map((row, index) => {
              const isEditable = row.type === "normal";

              return (
                <tr key={row.id.value}>
                  {/* A */}
                  <Td>{isEditable && <InputTable type="date" />}</Td>

                  {/* B */}
                  <Td>{isEditable && <InputTable type="text" />}</Td>

                  {/* C */}
                  <Td>{isEditable && <InputTable type="date" />}</Td>

                  {/* D */}
                  <Td style={{ textAlign: "left" }}>
                    {isEditable ? (
                      <InputTable type="text" />
                    ) : (
                      <strong>{row.description.value}</strong>
                    )}
                  </Td>

                  {/* E */}
                  <Td>{isEditable && <InputTable type="text" />}</Td>

                  {/* 1 */}
                  <Td style={{ textAlign: "center" }}>
                    {typeof row.debit.value === "string"
                      ? row.debit.value
                      : isEditable && <InputTable type="number" />}
                  </Td>

                  {/* 2 */}
                  <Td style={{ textAlign: "center" }}>
                    {typeof row.credit.value === "string"
                      ? row.credit.value
                      : isEditable && <InputTable type="number" />}
                  </Td>

                  {/* 3 */}
                  <Td style={{ textAlign: "center" }}>
                    {typeof row.balanceDebit.value === "string"
                      ? row.balanceDebit.value
                      : row.balanceDebit.value}
                  </Td>

                  {/* 4 */}
                  <Td style={{ textAlign: "center" }}>
                    {typeof row.balanceCredit.value === "string"
                      ? row.balanceCredit.value
                      : row.balanceCredit.value}
                  </Td>
                </tr>
              );
            })}
          </tbody>


        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box >
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
